import ProfileImg1 from "../assets/1.PNG"
import ProfileImg2 from "../assets/2.PNG"
import ProfileImg3 from "../assets/3.PNG"
import ProfileImg4 from "../assets/4.PNG"
import ProfileImg5 from "../assets/5.PNG"
import ProfileImg6 from "../assets/6.PNG"
import Instagram from "../svg/Instagram"
import Twitter from "../svg/Twitter"
import Mail from "../svg/Mail"
import FinishedSectionImg from "../assets/finished.jpg"
import SketchesSectionImg from "../assets/sketches.jpg"
import ComicSectionImg from "../assets/comic.png"
import ConceptArtSectionImg from "../assets/concept.png"
import CoverIllustrationSectionImg from "../assets/cover.png"

export const ownerData = {
    id: "uzomadraws",
    name: "Uzoma Draws",
    actualName: "Uzoma",
    signInEmail: "uzomadrawss@gmail.com",
    role: "Digital Illustrator",
    socials: [
        {
            name: "Instagram",
            socialTag: "uzomadrawsss",
            url: "https://www.instagram.com/uzomadrawsss/",
            svg: <Instagram />
        },
        {
            name: "Twitter",
            socialTag: "uzomadrawsss",
            url: "https://twitter.com/uzomadrawsss",
            svg: <Twitter />
        },
        {
            name: "Email",
            socialTag: "uzomadrawss@gmail.com",
            url: "mailto:uzomadrawss@gmail.com",
            svg: <Mail />
        },
        
    ]
};

export const profileImage = {
    multiple: true,
    images: [
        ProfileImg1,
        ProfileImg2,
        ProfileImg3,
        ProfileImg4,
        ProfileImg5,
        ProfileImg6
    ]
}

export const artSections = [
    {
        name: "Finished Work",
        imgUrl: FinishedSectionImg
    },
    {
        name: "Sketches",
        imgUrl: SketchesSectionImg
    },
    {
        name: "My Comic",
        imgUrl: ComicSectionImg
    },
    {
        name: "Concept Art",
        imgUrl: ConceptArtSectionImg
    },
    {
        name: "Cover Illustrations",
        imgUrl: CoverIllustrationSectionImg
    },
    
    
]